export class DashboardModel {
  buildings: number;
  periods: number;
  users: number;
  municipalities: number;

  constructor() {
    this.buildings = 0;
    this.periods = 0;
    this.users = 0;
    this.municipalities = 0;
  }
}
